import { captureException } from "@sentry/nextjs";
import { DECODED_TOKEN } from "@website/hooks/auth";
import jwtDecode from "jwt-decode";

export const decodeToken = (token: string): DECODED_TOKEN | null => {
  try {
    return jwtDecode(token) || null;
  } catch {
    captureException("Token was not decoded correctly", {
      tags: {
        errorType: "Token decoded",
        functionName: "decodeToken"
      }
    });
    return null;
  }
};

export const isTokenExpired = (
  token: string | null,
  currentTime: number
): boolean => {
  if (!token) return true;

  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    captureException("Token exp is not valid", {
      tags: {
        errorType: "Token decoded",
        functionName: "isTokenExpired"
      }
    });
    return true;
  }

  const now = Math.floor(currentTime / 1000);
  return decoded.exp < now;
};
